export enum VoucherTableFilterFields {
  STATUS = 'Status',
  TYPE = 'Type',
}

export const TestVoucherStatuses = ['assigned', 'unassigned'];
export type TestVoucherStatusType = (typeof TestVoucherStatuses)[number];

export const TestVoucherTypes = ['GRE', 'TOEFL', 'DUOLINGO', 'PTE'];
export type TestVoucherTypesType = (typeof TestVoucherTypes)[number];

export const STATUS_LABEL_MAP: Record<TestVoucherStatusType, string> = {
  ['assigned']: 'Assigned',
  ['unassigned']: 'Unassigned',
};

export const VOUCHER_TYPE_LABEL_MAP: Record<TestVoucherTypesType, string> = {
  ['PTE']: 'PTE',
  ['GRE']: 'GRE',
  ['TOEFL']: 'TOEFL',
  ['DUOLINGO']: 'Duolingo',
};
